export const adminEventSessionsTranslations = (params: { eventId: number }) => `event:${params.eventId}`;
